import Component from '@glimmer/component'

interface CartSummarySkeletonSignature {
  Element: HTMLDivElement
}

export default class CartSummarySkeleton extends Component<CartSummarySkeletonSignature> {
  <template>
    <div data-testid='cart-summary-skeleton' class='flex w-full flex-col gap-4 p-4' aria-hidden='true' ...attributes>
      <div class='flex flex-col gap-2'>
        <div class='skeleton-shimmer h-4 w-2/3 rounded'></div>
        <div class='skeleton-shimmer h-3 w-1/2 rounded'></div>
      </div>

      <div class='flex flex-col gap-2'>
        <div class='flex items-center justify-between gap-4'>
          <div class='skeleton-shimmer h-3 w-1/2 rounded'></div>
          <div class='skeleton-shimmer h-3 w-12 rounded'></div>
        </div>
        <div class='flex items-center justify-between gap-4'>
          <div class='skeleton-shimmer h-3 w-2/5 rounded'></div>
          <div class='skeleton-shimmer h-3 w-12 rounded'></div>
        </div>
      </div>

      <div class='flex items-center justify-between gap-4'>
        <div class='skeleton-shimmer h-4 w-16 rounded'></div>
        <div class='skeleton-shimmer h-4 w-20 rounded'></div>
      </div>
    </div>
  </template>
}
